<template>
  <div class="px-6 pb-8">
    <header class="mt-6 border-b-4">

          <h1 class="text-4xl">Work Orders</h1>

          <div class="flex mb-2 border-b pb-2">
            <select-dropdown class="text-xs mr-2" v-model="currentLine" :options="sortedLines" null-label="All Lines"></select-dropdown>
            <input type="text" v-model="filters.sku" class="text-xs rounded border py-1 px-2 leading-tight" placeholder="Product SKU"/>
          </div>
          <nav class="flex justify-between mb-2">

            <div class="flex items-center">

              <select-dropdown class="text-xs mr-2" v-model="filterType" :options="['Date Range','Search #']" null-label="All Open Orders"></select-dropdown>
              <div v-if="filterType === 'Date Range'" class="mr-2">
                <date-pick v-model="filters.startDate" format="YYYY-MM-DD" display-format="YYYY-MM-DD" class="rounded border p-1"></date-pick>
                <label class="mx-2">To</label>
                <date-pick v-model="filters.endDate" format="YYYY-MM-DD" display-format="YYYY-MM-DD" class="rounded border p-1"></date-pick>
              </div>
              <div v-else-if="filterType === 'Search #'" class="mr-2">
                <input type="text" v-model="filters.orderNum" class="text-xs rounded border py-1 px-2 leading-tight"/>
              </div>
              <div v-else></div>



              <button class="border rounded text-xs py-1 px-2 leading-tight" @click="loadOrders">GO</button>

            </div>
            <div>
              <button @click="exportReport" class="bg-teal-500 text-white px-3 py-1 rounded text-xs leading-tight mr-2">Export Logs</button>
              <button @click="onAddOrder" class="bg-orange-500 text-white px-3 py-1 rounded text-xs leading-tight">+ Add Order</button>
            </div>



          </nav>



    </header>
    <section class="">
      <table class="text-sm w-full">
        <thead class="text-left">
          <tr class="text-teal-500 border-b">
            
            <th class="py-2 px-2">Line</th>
            <th>Order #</th>
            <th class="hidden md:table-cell" >Product</th>
            <th>Order Amount</th>
            <th>Filled</th>
            <th class="hidden md:table-cell">Expected Start</th>
            <th>Actual Start</th>
            <th>Notes</th>

          </tr>
        </thead>
        <tbody>
          <tr v-for="order in workOrders" :key="order.number" class="text-gray-700 border-b hover:bg-gray-100 ">
              <td class="py-2 pl-4">{{ order.product.line }}</td>
            <td class="py-2 font-bold text-black"><router-link :to="'/orders/'+order.number" class="underline">{{ order.number }}</router-link></td>
            
            <td class="hidden md:table-cell">{{ order.product.description }}</td>
            <td>{{ order.amount_ordered | dashedblank }}</td>
            <td>{{ order.amount_filled }}</td>
            <td class="hidden md:table-cell"><span>{{ order.expected_start_date | datetime }}</span></td>

            <td><span v-if="order.actual_start_date">{{ order.actual_start_date | datetime }}</span><span class="italic opacity-50 ml-1" v-else>---</span></td>
            <td><span v-if="order.notes">{{ order.notes }}</span></td>





          </tr>
          
        </tbody>
        
      </table>
    </section>
    
  </div>
</template>

<script>
// @ is an alias to /src



import DatePick from  'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css';
import SelectDropdown from "../components/SelectDropdown";
import XLSX from "xlsx";

export default {
  name: 'packaging-overview',
  mounted: function(){

      console.log("Getting work orders");
      this.loadLines().then((lines) => {
          console.log("Lines loaded", lines);
          if(lines){
            this.lines = lines;
            this.loadOrders();
          }

      })
      //this.loadOrders();

      
  },
  components: {
    SelectDropdown,
    DatePick,

  },
  data: function(){
    return {
      workOrders: [],
      lines: [],
      currentLine: null,
      filters: {
        startDate: (new Date()).yyyymmdd(),
        endDate: (new Date()).yyyymmdd(1),
        openOnly: true,
        orderNum: null,
        sku: null
      },
      filterType: null //null is All Open

    }
  },

  computed: {
    sortedLines: function(){
      if(this.lines){
        return this.lines.map((line) => {
          return line.name;
        })
      }
      return []
    }
  },

  methods: {

    exportReport: function(){

      let rows = [
        ["Order Number", "SKU", "Description", "Expected Start", "","Actual Start","", "Order Amount", "Amount Filled",  "Goal PPM",  "Notes"],
      ]

      var orderCols = [
        {wch:15},
        {wch:15},
        {wch:50},
        {wch:15},
        {wch:10},
        {wch:15},
        {wch:10},
        {wch:15},
        {wch:15},
        {wch:10},
        {wch:60},

      ];





      let logs = [];

      this.loadOrdersForReport().then((orders) => {
        orders.forEach((order) => {
          rows.push([
            order.number,
            order.product.sku,
            order.product.description,

            order.expected_start_date?(new Date(order.expected_start_date)).mmddyyyy():"",
            order.expected_start_date?(new Date(order.expected_start_date)).HHmm():"",

            order.actual_start_date?(new Date(order.actual_start_date)).mmddyyyy():"",
            order.actual_start_date?(new Date(order.actual_start_date)).HHmm():"",

            // order.expected_start_date?(new Date(order.expected_start_date)).toLocaleString():"",
            // order.actual_start_date?(new Date(order.actual_start_date)).toLocaleString():"",

            // order.expected_start_date?Date.prototype.xlsDate(new Date(order.expected_start_date)):"",
            // order.actual_start_date?(new Date(order.actual_start_date)).toLocaleString():"",

            order.amount_ordered,
            order.amount_filled,

            order.product.expected_upm,

            order.notes
          ])

          console.log(order);

          if(order.logs && order.logs.length){
            logs = logs.concat(order.logs);
          }
        })

        console.log("Logs", logs);



        var wb = XLSX.utils.book_new();
        var today = new Date();
        wb.Props = {
          Title: "Work Order Report Data",
          CreatedDate: today
        }

        logs.sort((a,b) => {
          if (a.date < b.date){
            return 1;
          }else if(a.date > b.date ){
            return -1;
          }else{
            return 0;
          }
        })

        let productionLogs = [[ "ID", "Date","Time", "Line", "Work Order", "Count", "Details", "Notes"]];
        var productionCols = [
          {wch:15},
          {wch:15},
          {wch:10},
          {wch:15},
          {wch:15},
          {wch:15},
          {wch:20},
          {wch:60},

        ];
        let downtimeLogs = [[ "ID", "Date", "Time", "Line", "Work Order", "Minutes Down", "Machine", "Reason", "Solution/Fix"]];
        var downtimeCols = [
          {wch:15},
          {wch:15},
          {wch:10},
          {wch:15},
          {wch:15},
          {wch:15},
          {wch:20},
          {wch:20},
          {wch:60},

        ];
        let lossLogs = [[ "ID", "Date", "Time", "Line", "Work Order", "Loss Amount", "Machine", "Reason"]];
        var lossCols = [
          {wch:15},
          {wch:15},
          {wch:10},
          {wch:15},
          {wch:15},
          {wch:15},
          {wch:20},
          {wch:60},

        ];


        logs.forEach((log) => {
          if(log.tag === "count"){
            productionLogs.push(
                      [
                        log.id,
                        (new Date(log.date)).mmddyyyy(),
                        (new Date(log.date)).HHmm(),
                        log.line,
                        log.work_order,
                        log.value,
                        log.detail,
                        log.note
                      ]
              )
          }

          if(log.tag === "downtime"){
            downtimeLogs.push(
                    [
                      log.id,
                      (new Date(log.date)).mmddyyyy(),
                      (new Date(log.date)).HHmm(),
                      log.line,
                      log.work_order,
                      log.value,
                      log.code,
                      log.detail,
                      log.note
                    ]
            )
          }

          if(log.tag === "loss"){
            downtimeLogs.push(
                    [
                      log.id,
                      (new Date(log.date)).mmddyyyy(),
                      (new Date(log.date)).HHmm(),
                      log.line,
                      log.work_order,
                      log.value,
                      log.code,
                      log.note
                    ]
            )
          }
        })



        console.log(rows);
        var ws = XLSX.utils.aoa_to_sheet(rows);
        ws['!cols'] = orderCols;
        XLSX.utils.book_append_sheet(wb, ws, "Work Orders");

        var logWs = XLSX.utils.aoa_to_sheet(productionLogs);
        logWs['!cols'] = productionCols;
        XLSX.utils.book_append_sheet(wb, logWs, "Production Logs");

        var downtimeWs = XLSX.utils.aoa_to_sheet(downtimeLogs);
        downtimeWs['!cols'] = downtimeCols;
        XLSX.utils.book_append_sheet(wb, downtimeWs, "Downtime Logs");

        var lossWs = XLSX.utils.aoa_to_sheet(lossLogs);
        lossWs['!cols'] = lossCols;
        XLSX.utils.book_append_sheet(wb, lossWs, "Loss Logs");

        //
        XLSX.writeFile(wb, `work-order-report.xlsx`);
      })


    },

      loadLines: async function(){
        let lines = await this.$api.apiRequest("get","lines/")
                .then((response) => {


                  if(response && response.success){
                    console.log(response.success);
                    return response.success.data.results;
                  }else{
                    if(response.error){
                      console.log(response.error);
                    }
                    console.log("No lines returned from api");

                  }

                  return false;
                })
                .catch((error) => {
                  console.log("Error", error.response);
                  alert("Network error.");
                })

          return lines;
      },

      queryString: function(otherParams){

        var queryParams = [];
        if(otherParams){
          Object.keys(otherParams).forEach((key) =>{
            queryParams.push(key+"="+otherParams[key])
          })
          //queryParams.push("logs=true")
        }

        if(this.filterType){

          //var endDate = new Date(this.filters.endDate);



          switch (this.filterType) {
            case "Date Range":



              queryParams.push("start="+this.filters.startDate);
              queryParams.push("end="+this.filters.endDate+"T23:59");
              //queryParams.push("end="+endDate.addDays(1).yyyymmdd());

              //add a day to have for end date exclusive query
              break;

            case "Search #":
              queryParams.push("number="+this.filters.orderNum);
              break;

          }


        }else{
          queryParams.push("is_open=true")
        }

        if(this.filterType != "Search #"){
          if(this.filters.sku){
            queryParams.push("sku="+this.filters.sku);
          }

          if(this.currentLine){
            queryParams.push("&line="+this.currentLine);
          }

        }

        return ("?" + queryParams.join("&"));

      },

      loadOrdersForReport: async function(){

        // var queryString = "?";
        //
        // if(this.filterType){
        //
        //   var endDate = new Date(this.filters.endDate);
        //
        //
        //   switch (this.filterType) {
        //     case "Date Range":
        //
        //
        //
        //       queryString += ("start="+this.filters.startDate+"&end="+endDate.addDays(1).yyyymmdd()); //add a day to have for end date exclusive query
        //       break;
        //
        //     case "Search #":
        //       queryString += ("number="+this.filters.orderNum);
        //       break;
        //
        //   }
        //
        //
        // }else{
        //   queryString += "is_open=true"
        // }
        //
        // if(this.filterType != "Search #"){
        //   if(this.filters.sku){
        //     queryString += ("sku="+this.filters.sku);
        //   }
        //
        //   if(this.currentLine){
        //     queryString += ("&line="+this.currentLine);
        //   }
        //
        // }
        //
        //
        //
        //
        //
        // queryString += "&logs=true"

        let queryString = this.queryString({ logs: 'true' });


        let orders = await this.$api.apiRequest("get","workorders/"+queryString)
                .then((response) => {
                  if(response && response.success){
                    console.log(response.success);
                    return response.success.data.results;
                  }else{
                    if(response.error){
                      console.log(response.error);
                    }
                    console.log("No results returned from api");
                  }

                  return false;
                })
                .catch((error) => {
                  console.log("Error", error.response);
                  alert("Network error.");
                })

        return orders;

      },

      loadOrders: function(){

           // var queryString = "?";
           //
           // if(this.filterType){
           //
           //     var endDate = new Date(this.filters.endDate);
           //
           //
           //     switch (this.filterType) {
           //         case "Date Range":
           //
           //
           //
           //             queryString += ("start="+this.filters.startDate+"&end="+endDate.addDays(1).yyyymmdd()); //add a day to have for end date exclusive query
           //             break;
           //
           //         case "Search #":
           //             queryString += ("number="+this.filters.orderNum);
           //             break;
           //
           //         case "Product SKU":
           //           queryString += ("sku="+this.filters.sku);
           //           break;
           //     }
           //
           //
           // }else{
           //     queryString += "is_open=true"
           // }
           //
           // if(this.currentLine && this.filterType != "Search #"){
           //   queryString += ("&line="+this.currentLine);
           // }

            let queryString = this.queryString();


           this.$api.apiRequest("get","workorders/"+queryString)
      .then((response) => {
          if(response && response.success){
            console.log(response.success);
            this.workOrders = response.success.data.results;
          }else{
            if(response.error){
              console.log(response.error);
            }
            console.log("No results returned from api");
          }
        })
        .catch((error) => {
          console.log("Error", error.response);
          alert("Network error.");
        })
      },

      onAddOrder: function(){
          this.$router.push({ name: "create-order" });
      }

  }
}
</script>

<style scoped>



</style>
